import { AnyFactories, AnyModels } from 'miragejs/-types'
import { Server, Registry } from 'miragejs'

import { baseURL } from 'configs/api'
import { LOGIN_POST_SUCCESS_RESPONSE } from './data'
import { setResponse } from 'utils/mirage'

export function loginHandlers(
  server: Server<Registry<AnyModels, AnyFactories>>
) {
  server.post(
    `${baseURL}/teachers/v1alpha1/login`,
    setResponse(() => LOGIN_POST_SUCCESS_RESPONSE)
  )
}

export function loginV2Handlers(
  server: Server<Registry<AnyModels, AnyFactories>>
) {
  server.post(
    `${baseURL}/teachers/v1alpha2/login`,
    setResponse(() => LOGIN_POST_SUCCESS_RESPONSE)
  )
}
